import axios from 'axios';
import React from "react";
import ReactDOM from "react-dom";
import {setCurrentUser, setInstaller} from './actions/authActions';
import {Provider} from 'react-redux';
import store from './store';

import { HashRouter, Route, Switch } from "react-router-dom";

import PrivateRoute from './components/Common/PrivateRoute';

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/sass/light-bootstrap-dashboard.css?v=1.2.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";

import Login from './layouts/Login';
import Dashboard from './layouts/Dashboard/Dashboard'

axios.interceptors.request.use((config) => {
    if (localStorage.sessionToken) {
        if (config.params == null) {
            config.params = {};
        }
        config.params['session'] = localStorage.sessionToken;
    }
    return config;
});

if (localStorage.sessionToken) {
    const user = JSON.parse(localStorage.user);
    const shop = JSON.parse(localStorage.shop);

    //store.dispatch(reloadProfile({session: localStorage.sessionToken}));
    store.dispatch(setInstaller(shop));
    store.dispatch(setCurrentUser(user));
}

ReactDOM.render(
    <Provider store={store}>
    <HashRouter>
        <div className="App">
            <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap" rel="stylesheet" />
            <link href="https://fonts.googleapis.com/css?family=Barlow:300,400,500,700&display=swap" rel="stylesheet" />
            <Route exact path="/" component={Login} />
            <Switch>
                <PrivateRoute exact path="/dashboard" component={Dashboard} />
                <PrivateRoute exact path="/user" component={Dashboard} />
                <PrivateRoute exact path="/schedule" component={Dashboard} />
                <PrivateRoute exact path="/availability" component={Dashboard} />
                <PrivateRoute exact path="/notifications" component={Dashboard} />
                <PrivateRoute exact path="/forms" component={Dashboard} />
                <PrivateRoute exact path="/updatepassword" component={Dashboard} />
            </Switch>
        </div>
    </HashRouter>
    </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js